// Setup › Company › Billing (`/c/{slug}/setup/billing?topup=`; WALLET-P1 §6.1): the company's
// prepaid AI credit. Setup's roles (owners, admins, agency operators); members and client viewers
// get Setup's no-access page, as the API answers them 404. `?topup=` is Checkout's return.
import { createRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { BillingPage } from "../features/billing/billing-page";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupBillingRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "billing",
  validateSearch: (search: Record<string, unknown>): { topup?: string } =>
    typeof search.topup === "string" && /^[\w-]{1,64}$/.test(search.topup)
      ? { topup: search.topup }
      : {},
  component: function SetupBilling() {
    const { api } = setupBillingRoute.useRouteContext();
    const { topup } = setupBillingRoute.useSearch();
    const navigate = useNavigate();
    const company = useCompany();
    const seen = useCallback(
      () =>
        void navigate({
          to: "/c/$slug/setup/billing",
          params: { slug: company.slug },
          search: {},
          replace: true,
        }),
      [navigate, company.slug],
    );
    return <BillingPage api={api} company={company} topup={topup} onTopupSeen={seen} />;
  },
});
